'use strict';

/* globals define, config, ajaxify, socket, app, $ */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/survey/survey-editor', [
	config.relative_path + '/plugins/nodebb-plugin-surveys/static/vendor/vue.js',
	'translator',
	'benchpress',
	'surveyCreator',
	'stringify',
	'slugify',
	'bootbox',
], function (vue, translator, Benchpress, surveyCreator, stringify, slugify, bootbox) {
	var	SurveyEditor = {};

	SurveyEditor.init = function () {
		surveyCreator.init(ajaxify.data.survey, ajaxify.data.translations);

		addActions();
	};

	function addActions() {
		var actions = {
			update: updateSurvey,
			publish: publishSurvey,
			delete: deleteSurvey,
		};

		for (var key in actions) {
			if (actions.hasOwnProperty(key)) {
				$('[data-action="' + key + '"]').click(actions[key]);
			}
		}
	}

	function updateSurvey() {
		save('plugins.surveys.updateSurvey');
	}

	function publishSurvey() {
		save('plugins.surveys.publishSurvey');
	}

	function save(saveUrl) {
		applyFormValues();

		var data = $.extend({}, ajaxify.data.survey, { questions: getParsedQuestions() });

		socket.emit(saveUrl, data, function (err) {
			if (err) {
				return app.alertError(err.message);
			}

			app.alert({
				alert_id: 'survey_edited',
				message: '[[surveys:survey-edited]]',
				type: 'success',
				timeout: 2000,
			});

			ajaxify.go('groups/' + ajaxify.data.group.slug + '/survey/' + ajaxify.data.survey.surveyId + '/' + slugify(ajaxify.data.survey.name));
		});
	}

	function getParsedQuestions() {
		var questions = [];

		for (var questionIndex = 0; questionIndex < ajaxify.data.survey.questions.length; questionIndex++) {
			var question = ajaxify.data.survey.questions[questionIndex];

			var answers = [];

			for (var answerIndex = 0; answerIndex < question.answers.length; answerIndex++) {
				var answer = question.answers[answerIndex];

				answers.push({
					weight: answer.weight,
					label: answer.label,
				});
			}

			questions.push({
				id: question.id,
				question: question.question,
				answers: answers,
			});
		}

		return questions;
	}

	function applyFormValues() {
		ajaxify.data.survey.name = $('#name').val();
		ajaxify.data.survey.isVisible = $('#isVisible').is(':checked');
	}

	function deleteSurvey() {
		bootbox.confirm('Do you want to delete survey?', function (confirm) {
			if (!confirm) {
				return;
			}

			var data = $.extend({}, ajaxify.data.survey, { questions: [] });

			socket.emit('plugins.surveys.removeSurvey', data, function (err) {
				if (err) {
					return app.alertError(err.message);
				}

				app.alert({
					alert_id: 'survey_removed',
					message: '[[surveys:survey-removed]]',
					type: 'success',
					timeout: 2000,
				});

				ajaxify.go('groups/' + ajaxify.data.group.slug + '/surveys');
			});
		});
	}

	return SurveyEditor;
});
